export default __webpack_public_path__ + "static/media/minus.ba45fe6c.svg";